export default __webpack_public_path__ + "static/media/numberInput.be39183c.gif";